export const MAP_LAYOUTS = {
	1: [
		"===========================",
		"=@ ?                   #  =",
		"=                         =",
		"=                         =",
		"= $            %          =",
		"=                         =",
		"=         $              $=",
		"===========================",
	],
	2: [
		"==========                           ",
		"=@       =                           ",
		"=        =           =====           ",
		"=        =           =   =           ",
		"=        =           = $ =           ",
		"=        =============   =========   ",
		"= $                              =   ",
		"=         &                      ====",
		"=                                   =",
		"=   #       %                     $ =",
		"=               $                ====",
		"==================================   ",
	],
	3: [
		"=======================================",
		"=                     #               =",
		"=@     $                            $ =",
		"========                             ==",
		"       =            %             ====",
		"       =         &                =   ",
		"       =                          =   ",
		"       = $                        =   ",
		"       ===================        ====",
		"                         =  $        =",
		"                         =     &     =",
		"                         =  $        =",
		"                         ==========  =",
		"                                =    =",
		"                                = $  =",
		"                                ======",
	],
	4: [
		"                    ======================",
		"                    =                    =",
		"========            =         &    $     =",
		"= @    =            =                    =",
		"=      =            =    =============   =",
		"=      =            =    =           =   =",
		"=      ==============    =           =   =",
		"=                        =============   =",
		"=             %   $                =     =",
		"=============                      =  &  =",
		"            =                      =     =",
		"            =      ============   ====   =",
		"            =      =          =   =  =   =",
		"            =     $=          =   =  =   =",
		"            ========          =   ====   =",
		"                              =          =",
		"                              = $   &    =",
		"                              =          =",
		"                              ============",
	],
	5: [
		"==========================================",
		"= @           #                          =",
		"=                     %                  =",
		"=                                        =",
		"=                                        =",
		"=                                        =",
		"=                                        =",
		"============================             =",
		"                           =     &       =",
		"                           =        $    =",
		"                           =    &        =",
		"                           =             =",
		"                           =    &        =",
		"                           =             =",
		"                           =        &    =",
		"                           =             =",
		"                           = $   $   $   =",
		"                           =   $   $     =",
		"                           ===============",
	],
	6: [
		"=======               ",
		"=@    =        =======",
		"=     =        =    #=",
		"=     =        =     =",
		"= &   =        =     =",
		"=     =        =  &  =",
		"=  &  =        =     =",
		"=     =        =  &  =",
		"=     =        =     =",
		"= $   ==========     ====================",
		"=                                       =",
		"=                            $ %     $  =",
		"=                          $    $    %  =",
		"=                     %      $    % $   =",
		"=                         %  %  $    $  =",
		"=                            $      $   =",
		"=========================================",
	]
};

const reset_data = {
	paused: false,
	life: 3,
	fuse_held: 0,
	fuse_dropped: 0,
};

const level_data = {
	1: {
		fuse_needed: 3,
		ghost_lasts: 2,
		time: {
			m: 0,
			s: 20,
		},
	},
	2: {
		fuse_needed: 4,
		time: {
			m: 0,
			s: 20,
		},
	},
	3: {
		fuse_needed: 6,
		time: {
			m: 0,
			s: 30,
		},
	},
	4: {
		fuse_needed: 6,
		time: {
			m: 0,
			s: 30,
		},
	},
	5: {
		fuse_needed: 6,
		time: {
			m: 0,
			s: 59,
		},
	},
	6: {
		fuse_needed: 10,
		time: {
			m: 0,
			s: 59,
		},
	},
};

export function getLevelData(level) {
	return { ...level_data[level], ...reset_data };
}
